import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { authService } from 'services/auth.services'
import store from 'store'

const initialState = {
  isUserLoggedIn: store.get(`${process.env.REACT_APP_ACCESS_TOKEN_KEY}`) ? true : false,
  loggedInUser: {},
  loading: false
}

export const setLoggedInUser = createAsyncThunk('setLoggedInUser', async () => {
  return await authService.getMe()
})

const sessionSlice = createSlice({
  name: 'session',
  initialState: initialState,
  reducers: {
    setTokenSession: (state, action) => {
      store.set(process.env.REACT_APP_ACCESS_TOKEN_KEY || '', action.payload)
      state.isUserLoggedIn = true
    },

    destroyAuthSession: (state) => {
      store.clearAll()
      state.isUserLoggedIn = false
      state.loggedInUser = {}
      window.location.replace('/login')
    }
  },
  extraReducers: (builder) => {
    builder.addCase(setLoggedInUser.fulfilled, (state, action) => {
      state.loggedInUser = action.payload
    })
  }
})

export const { setTokenSession, destroyAuthSession } = sessionSlice.actions

export default sessionSlice.reducer
